import http from "../../../core/utils/apis/api";

const register = async (signupData) => {
    try {
        const response = await http({
            method: "POST",
            url: `/auth/register`,
            data: signupData
        });
        return response;
    } catch (e) {
        throw e;
    }
};

const registerService = {
    register
};

export default registerService;
